import { BeanStatus } from 'src/bean/BeanStatus';
export class BeanStatusMonitory {

  stmoIdCdStatusMonitoria: string | null;
  moniIdCdMonitoria: string | null;
  statIdCdStatus: string | null;
  usuaIdCdUsuario: string | null;
  usuaNmUsuario: string | null;
  stmoDhRegistro: string | null;
  status: BeanStatus | null;
  operIdCdOperacao: string | null;
}
